function padDatePart (value) {
  return value < 10 ? '0' + value : String(value)
}

function toLocalDateTimeInputValue (date) {
  if (!(date instanceof Date) || !Number.isFinite(date.getTime())) {
    return null
  }

  return date.getFullYear() + '-' + padDatePart(date.getMonth() + 1) + '-' + padDatePart(date.getDate()) +
    'T' + padDatePart(date.getHours()) + ':' + padDatePart(date.getMinutes())
}

function startOfLocalDay (now) {
  const start = now ? new Date(now.getTime()) : new Date()
  start.setHours(0, 0, 0, 0)
  return start
}

function startOfLocalDayInput (now) {
  return toLocalDateTimeInputValue(startOfLocalDay(now))
}

function defaultLocalDateToInput (now) {
  const from = startOfLocalDay(now)
  const to = now ? new Date(now.getTime()) : new Date()
  if (to.getTime() <= from.getTime()) {
    to.setMinutes(to.getMinutes() + 1)
  }
  return toLocalDateTimeInputValue(to)
}

/**
 * datetime-local has no timezone suffix. Date parses it as the device local clock,
 * and toISOString() turns that instant into UTC for the API.
 */
function localDateTimeInputToUtcIso (value) {
  if (!value) {
    return null
  }

  const parsed = new Date(value)
  if (!Number.isFinite(parsed.getTime())) {
    return null
  }

  return parsed.toISOString()
}

function resolveCreditPeriodTotalsRequest ({ agentProfileId, dateFromLocal, dateToLocal }) {
  const dateFrom = localDateTimeInputToUtcIso(dateFromLocal)
  const dateTo = localDateTimeInputToUtcIso(dateToLocal)

  if (!agentProfileId || !dateFrom || !dateTo) {
    return { error: 'Date range is required' }
  }

  if (new Date(dateFrom).getTime() >= new Date(dateTo).getTime()) {
    return { error: 'From must be earlier than To' }
  }

  return {
    dateFrom: dateFrom,
    dateTo: dateTo
  }
}

module.exports = {
  toLocalDateTimeInputValue,
  startOfLocalDay,
  startOfLocalDayInput,
  defaultLocalDateToInput,
  localDateTimeInputToUtcIso,
  resolveCreditPeriodTotalsRequest
}
